import React, { useId, useState } from 'react';
import { CHECK, CHOICE_ROW, INPUT } from './styles';

const SEARCH_THRESHOLD = 8;

/** Checkbox list; value is an array of option values. Searchable when the list is long. */
const MultiSelectRenderer = ({ field, value, onChange }) => {
    const [query, setQuery] = useState('');
    const id = useId();
    const selected = Array.isArray(value) ? value : [];
    const options = field.options || [];
    const needle = query.trim().toLowerCase();
    const shown = needle ? options.filter((o) => String(o.label).toLowerCase().includes(needle)) : options;

    const toggle = (v) => {
        const next = selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v];
        onChange(next);
    };

    if (options.length === 0) {
        return <p className="px-2 py-1 text-sm text-slate-500">{field.emptyText || 'No options available.'}</p>;
    }

    return (
        <div className="space-y-2">
            {options.length > SEARCH_THRESHOLD && (
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder={`Search ${field.label.toLowerCase()}…`}
                    aria-label={`Search ${field.label.toLowerCase()} options`}
                    className={INPUT}
                />
            )}
            <fieldset className="max-h-60 space-y-0.5 overflow-y-auto">
                <legend className="sr-only">{field.label}</legend>
                {shown.length === 0 && <p className="px-2 py-1 text-sm text-slate-500">No matches.</p>}
                {shown.map((o) => {
                    const optionId = `${id}-${o.value}`;
                    return (
                        <label key={o.value} htmlFor={optionId} className={CHOICE_ROW}>
                            <input
                                id={optionId}
                                type="checkbox"
                                className={CHECK}
                                checked={selected.includes(String(o.value))}
                                onChange={() => toggle(String(o.value))}
                            />
                            <span className="min-w-0 flex-1 truncate" title={o.label}>
                                {o.label}
                            </span>
                            {o.hint && <span className="shrink-0 text-xs text-slate-500">{o.hint}</span>}
                        </label>
                    );
                })}
            </fieldset>
        </div>
    );
};

export default MultiSelectRenderer;
